import { getRequestIdFromError } from "@/lib/observability/app-error"

import { UserMessage } from "./codes"
import { normalizeError, type NormalizedError } from "./normalize"

export function getUserErrorMessage(error: unknown, fallback: string = UserMessage.GENERIC): string {
  const normalized = normalizeError(error)
  return normalized.userMessage || fallback
}

export function getErrorReferenceId(error: unknown): string | undefined {
  return normalizeError(error).requestId ?? getRequestIdFromError(error)
}

export function describeError(error: unknown, prefix = UserMessage.LOAD_FAILED): NormalizedError {
  const normalized = normalizeError(error)
  if (prefix === UserMessage.LOAD_FAILED) return normalized
  return { ...normalized, userMessage: `${prefix} ${normalized.userMessage}` }
}
